import request from '../request.js'

// 获取虚拟组织信息（张卫华）
const getAllGroups = function (data) {
    return request({
        url: 'sysGroup/getAllGroups',
        method: 'post',
        data
    })
}

export {
    getAllGroups
}